import { generateClient } from 'aws-amplify/api';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { fetchAuthSession } from 'aws-amplify/auth';


//production
const API_KEY = 'da2-tax3nurfvracrh527dgmfxvdlm';
const GRAPHQL_ENDPOINT = 'https://h5d7cqtrjnhw7mc7pktq467y6q.appsync-api.us-east-1.amazonaws.com/graphql';

//testing
// const API_KEY = 'da2-whvqjib6t5g4rl3w4u6dxvp2rm';
// const GRAPHQL_ENDPOINT = 'https://ztod4ik4mrgqpj5v4k4ypr6yl4.appsync-api.us-east-1.amazonaws.com/graphql';


const REST_OTP_GATEWAY_ENDPOINT = "https://xjmn0g1tf5.execute-api.us-east-1.amazonaws.com/production/generate-email-otp";

export const requestOTPClient = axios.create({
    baseURL: REST_OTP_GATEWAY_ENDPOINT,
    headers: {
        'Content-Type': 'application/json',
        'x-transaction-id': uuidv4(),
    },
});

export const requestAPIClient = axios.create({
    baseURL: GRAPHQL_ENDPOINT,
    headers: {
        'Content-Type': 'application/json',
        'x-transaction-id': uuidv4(),
        'x-api-key': API_KEY,
    },
});

export const requestSSOClient = (typeOfSSO, idToken, email, otp) => {
    let authorization_string = '';

    // Determine the authorization string based on the typeOfSSO
    if (typeOfSSO === 'emailVerify') {
        authorization_string = `emailVerify$${email}$${otp}`;
    } else if (typeOfSSO === 'sso') {
        authorization_string = `sso$${idToken}`;
    }

    // Generate the client with the appropriate headers
    return axios.create({
        baseURL: GRAPHQL_ENDPOINT,
        headers: {
            'Content-Type': 'application/json',
            'x-transaction-id': uuidv4(),  // Generate a new transaction ID for each request
            Authorization: authorization_string,  // Dynamically set the Authorization header
        },
    });
};

export const requestCognitoClient = (idToken) => {
    return axios.create({
        baseURL: GRAPHQL_ENDPOINT,
        headers: {
            'Content-Type': 'application/json',
            'x-transaction-id': uuidv4(),
            'Authorization': `${idToken}`
        },
    });
}

